// Mobile Menu Toggle
const hamburger = document.querySelector('.hamburger');
const navMenu = document.querySelector('.nav-menu');

hamburger.addEventListener('click', () => {
    navMenu.classList.toggle('active');
    hamburger.classList.toggle('active');
});

// Close mobile menu when clicking on a link
document.querySelectorAll('.nav-menu a').forEach(link => {
    link.addEventListener('click', () => {
        navMenu.classList.remove('active');
        hamburger.classList.remove('active');
    });
});

// Scroll Animation Observer
const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('aos-animate');
        }
    });
}, observerOptions);

// Observe all elements with data-aos attribute
document.querySelectorAll('[data-aos]').forEach(element => {
    observer.observe(element);
});

// Navbar Background on Scroll
const navbar = document.querySelector('.navbar');
let lastScroll = 0;

window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > 100) {
        navbar.style.background = 'rgba(28, 28, 30, 0.95)'; // Dark grey
        navbar.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.3)';
    } else {
        navbar.style.background = 'rgba(0, 0, 0, 0.8)'; // Dark with transparency
        navbar.style.boxShadow = 'none';
    }
    
    lastScroll = currentScroll;
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            const offsetTop = target.offsetTop - 80;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    });
});

// Video lazy loading optimization
const videos = document.querySelectorAll('video');

const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const video = entry.target;
            if (video.paused) {
                video.play();
            }
        } else {
            const video = entry.target;
            if (!video.paused) {
                video.pause();
            }
        }
    });
}, {
    threshold: 0.25
});

videos.forEach(video => {
    videoObserver.observe(video);
});

// Hero video scrolls normally with the page (no parallax or fade effects)

// Prevent videos from playing when not in viewport (performance optimization)
document.addEventListener('DOMContentLoaded', () => {
    const featureVideos = document.querySelectorAll('.feature-media video');
    
    featureVideos.forEach(video => {
        // Add loading="lazy" attribute for better performance
        video.setAttribute('loading', 'lazy');
        video.setAttribute('preload', 'metadata');
    });
});

// Add active state to navigation based on scroll position
window.addEventListener('scroll', () => {
    const sections = document.querySelectorAll('section[id]');
    const scrollY = window.pageYOffset;

    sections.forEach(section => {
        const sectionHeight = section.offsetHeight;
        const sectionTop = section.offsetTop - 100;
        const sectionId = section.getAttribute('id');
        const navLink = document.querySelector(`.nav-menu a[href="#${sectionId}"]`);

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            if (navLink) {
                document.querySelectorAll('.nav-menu a').forEach(link => {
                    link.style.color = '';
                });
                navLink.style.color = '#0071e3';
            }
        }
    });
});

// Mouse parallax effect removed - text stays fixed

// ===== DECAL SHOWCASE FUNCTIONALITY =====

// Track current selected decal and color
let currentDecal = 1;
let currentColor = 'black';
let currentDecalName = 'Circular';

// Placeholder image mapping (until real decal images are added)
const decalImages = {
    1: 'PXL_20251013_033652870.jpg',
    2: 'PXL_20251013_143558169.jpg',
    3: 'PXL_20251018_011501420.jpg',
    4: 'PXL_20251013_033652870.jpg',
    5: 'PXL_20251013_143558169.jpg',
    6: 'PXL_20251018_011501420.jpg',
    7: 'PXL_20251013_033652870.jpg'
};

// Function to select a decal
function selectDecal(decalNumber, decalName) {
    currentDecal = decalNumber;
    currentDecalName = decalName;
    
    // Update main image
    updateMainImage();
    
    // Update active state on cards
    const cards = document.querySelectorAll('.decal-card');
    cards.forEach((card, index) => {
        if (index + 1 === decalNumber) {
            card.classList.add('active');
        } else {
            card.classList.remove('active');
        }
    });
    
    // Update decal name
    const nameElement = document.getElementById('decalMainName');
    if (nameElement) {
        nameElement.textContent = decalName;
    }
}

// Function to switch between black and white
function switchColor(color) {
    currentColor = color;
    
    // Update main image
    updateMainImage();
    
    // Update button states
    const buttons = document.querySelectorAll('.color-btn');
    buttons.forEach(btn => {
        if (btn.getAttribute('data-color') === color) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });
    
    // Update thumbnail overlays
    const thumbnails = document.querySelectorAll('.decal-thumbnail');
    thumbnails.forEach(thumb => {
        const blackImg = thumb.querySelector('.thumb-black');
        const whiteImg = thumb.querySelector('.thumb-white');
        
        if (color === 'white') {
            blackImg.style.opacity = '0';
            whiteImg.style.opacity = '1';
        } else {
            blackImg.style.opacity = '1';
            whiteImg.style.opacity = '0';
        }
    });
}

// Function to update main display image
function updateMainImage() {
    const mainImage = document.getElementById('decalMainImage');
    if (mainImage) {
        // Map decal names to their FULL Shopify CDN URLs
        const decalFileMap = {
            'Circular': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/Circularblack.jpg?v=1760992709', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/circularwhite.jpg?v=1760992709' 
            },
            'Hexagonal': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/hexagonalblack.jpg?v=1760992709', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/hexagonalwhite.jpg?v=1760992709' 
            },
            'PCB': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/pcbblack.jpg?v=1760990709', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/pcbwhite.jpg?v=1760992709' 
            },
            'Shards': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/shardsblack.jpg?v=1760992709', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/shardswhite.jpg?v=1760992709' 
            },
            'Wave': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/waveblack.jpg?v=1760992709', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/wavewhite.jpg?v=1760990706' 
            },
            'Angular': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/MG_5032.jpg?v=1761124575', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/angularwhite.jpg?v=1760992709' 
            },
            'Swirl': { 
                black: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/swirlblack.jpg?v=1760992708', 
                white: 'https://cdn.shopify.com/s/files/1/0784/8571/7235/files/swirlblack.jpg?v=1760992708' 
            }
        };
        
        // Get the appropriate image URL
        const decalData = decalFileMap[currentDecalName];
        if (decalData && decalData[currentColor]) {
            const imagePath = decalData[currentColor];
            mainImage.src = imagePath;
            mainImage.alt = currentDecalName + ' - ' + currentColor + ' version';
        }
    }
}

// Function to scroll the gallery
function scrollGallery(direction) {
    const gallery = document.getElementById('decalGallery');
    if (!gallery) return;
    
    const scrollAmount = 220; // Card width + gap
    
    if (direction === 'left') {
        gallery.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    } else {
        gallery.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }
}

// Initialize decal showcase on page load
document.addEventListener('DOMContentLoaded', () => {
    // Set initial decal
    const initialName = document.querySelector('.decal-card.active .decal-card-name');
    if (initialName) {
        currentDecalName = initialName.textContent;
        const nameElement = document.getElementById('decalMainName');
        if (nameElement) {
            nameElement.textContent = currentDecalName;
        }
    }
    
    // Add keyboard navigation for gallery
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
            scrollGallery('left');
        } else if (e.key === 'ArrowRight') {
            scrollGallery('right');
        }
    });
    
    // Add touch swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    const gallery = document.getElementById('decalGallery');
    if (gallery) {
        gallery.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        });
        
        gallery.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        });
    }
    
    function handleSwipe() {
        if (touchEndX < touchStartX - 50) {
            scrollGallery('right');
        }
        if (touchEndX > touchStartX + 50) {
            scrollGallery('left');
        }
    }
});

// ===== SOFTWARE TAB SWITCHING =====

function switchSoftwareTab(tabName) {
    // Update tab buttons
    const tabs = document.querySelectorAll('.software-tab');
    tabs.forEach(tab => {
        const tabButton = tab;
        // Check if this tab matches the clicked one
        if (tab.onclick && tab.onclick.toString().includes(`'${tabName}'`)) {
            tab.classList.add('active');
        } else {
            tab.classList.remove('active');
        }
    });
    
    // Update panels
    const panels = document.querySelectorAll('.demo-panel');
    panels.forEach(panel => {
        if (panel.id === `panel-${tabName}`) {
            panel.classList.add('active');
        } else {
            panel.classList.remove('active');
        }
    });
}

// ===== SOFTWARE SECTION INTERACTIVITY =====

// Select animation preset
function selectAnimationPreset(presetElement) {
    // Remove active class from all presets
    const presets = document.querySelectorAll('.animation-preset');
    presets.forEach(preset => preset.classList.remove('active'));
    
    // Add active class to clicked preset
    presetElement.classList.add('active');
    
    // Get the animation type from the preset name
    const presetName = presetElement.querySelector('span').textContent.toLowerCase();
    const ledStrip = document.querySelector('.led-strip');
    
    if (ledStrip) {
        // Remove all animation classes
        ledStrip.className = 'led-strip';
        
        // Force reflow to restart animations
        ledStrip.offsetHeight;
        
        // Apply the appropriate animation class based on preset
        if (presetName.includes('rainbow')) {
            ledStrip.classList.add('rainbow');
        } else if (presetName.includes('pulse')) {
            ledStrip.classList.add('pulse');
        } else if (presetName.includes('breathe')) {
            ledStrip.classList.add('breathe');
        } else if (presetName.includes('strobe')) {
            ledStrip.classList.add('strobe');
        } else if (presetName.includes('fade')) {
            ledStrip.classList.add('fade');
        } else if (presetName.includes('fire')) {
            ledStrip.classList.add('fire');
        }
        
        // Force animation restart on all pixels
        setTimeout(function() {
            const pixels = ledStrip.querySelectorAll('.strip-pixel');
            for (let i = 0; i < pixels.length; i++) {
                pixels[i].style.animation = 'none';
                pixels[i].offsetHeight;
                pixels[i].style.animation = '';
            }
        }, 10);
    }
    
    // Add a visual feedback
    presetElement.style.transform = 'scale(0.95)';
    setTimeout(function() {
        presetElement.style.transform = '';
    }, 100);
}

// Select drawing tool
function selectDrawTool(toolElement) {
    // Remove active class from all tools
    const tools = document.querySelectorAll('.tool-option');
    tools.forEach(tool => tool.classList.remove('active'));
    
    // Add active class to clicked tool
    toolElement.classList.add('active');
    
    // Visual feedback
    toolElement.style.transform = 'scale(0.95)';
    setTimeout(function() {
        toolElement.style.transform = '';
    }, 100);
}

// Select color from palette
function selectColorOption(colorElement) {
    // Remove active class from all colors
    const colors = document.querySelectorAll('.color-option');
    colors.forEach(color => color.classList.remove('active'));
    
    // Add active class to clicked color
    colorElement.classList.add('active');
    
    // Don't change existing pixels - only sets the color for NEW pixels you activate
    
    // Visual feedback
    colorElement.style.transform = 'scale(1.1)';
    setTimeout(function() {
        colorElement.style.transform = '';
    }, 150);
}

// Toggle LED pixel (for drawing demo)
function toggleLEDPixel(pixelElement) {
    const wasActive = pixelElement.classList.contains('active');
    pixelElement.classList.toggle('active');
    
    // If activating the pixel, apply the currently selected color
    if (!wasActive) {
        const activeColor = document.querySelector('.color-option.active');
        if (activeColor) {
            const selectedColor = activeColor.style.background;
            pixelElement.style.background = selectedColor;
            pixelElement.style.boxShadow = `0 0 15px ${selectedColor}, 0 0 30px ${selectedColor}`;
        }
    } else {
        // If deactivating, reset to default
        pixelElement.style.background = '';
        pixelElement.style.boxShadow = '';
    }
    
    // Visual feedback
    pixelElement.style.transform = 'scale(1.2)';
    setTimeout(function() {
        pixelElement.style.transform = '';
    }, 100);
}

// Make all LED pixels clickable on page load
document.addEventListener('DOMContentLoaded', () => {
    const ledPixels = document.querySelectorAll('.led-pixel');
    ledPixels.forEach(pixel => {
        pixel.style.cursor = 'pointer';
        pixel.addEventListener('click', function() {
            toggleLEDPixel(this);
        });
    });
});

// ===== TEMPERATURE MONITORING ANIMATION =====

// Animate temperature values to simulate live monitoring
let tempAnimationInterval = null;

function updateTempBar(temperature) {
    const pixels = document.querySelectorAll('.temp-pixel');
    if (pixels.length !== 40) return; // 5x8 grid
    
    // Calculate how many rows to fill (0-8) based on temp
    // 40°C = 1 row, 50°C = 2 rows, 60°C = 4 rows, 70°C = 5 rows, 80°C = 6 rows, 90°C = 7 rows, 100°C = 8 rows
    const tempPercent = Math.max(0, Math.min(100, (temperature - 40) / 60)); // 40-100°C range
    const rowsFilled = Math.round(tempPercent * 8);
    
    // Color mapping (bottom to top, warmer as it goes up)
    const colorMap = [
        'active-red',      // Row 1 (top) - hottest
        'active-red',      // Row 2
        'active-orange',   // Row 3
        'active-yellow',   // Row 4
        'active-yellow',   // Row 5
        'active-cyan',     // Row 6
        'active-blue',     // Row 7
        'active-blue'      // Row 8 (bottom) - coldest
    ];
    
    // Update each pixel (grid is organized top to bottom in HTML)
    for (let row = 0; row < 8; row++) {
        for (let col = 0; col < 5; col++) {
            const pixelIndex = row * 5 + col;
            const pixel = pixels[pixelIndex];
            
            // Row 0 is top, row 7 is bottom
            // Fill from bottom up: if (7 - row) < rowsFilled
            if ((7 - row) < rowsFilled) {
                // Remove all color classes
                pixel.className = 'temp-pixel';
                // Add the appropriate color for this row
                pixel.classList.add(colorMap[row]);
            } else {
                // Turn off pixel
                pixel.className = 'temp-pixel';
            }
        }
    }
}

function animateTemperatures() {
    // Clear any existing interval
    if (tempAnimationInterval) {
        clearInterval(tempAnimationInterval);
    }
    
    const cpuTempElement = document.querySelector('.cpu-temp');
    const gpuTempElement = document.querySelector('.gpu-temp');
    
    if (!cpuTempElement || !gpuTempElement) return;
    
    let cpuTemp = 50;
    let gpuTemp = 48;
    let increasing = true;
    
    // Initial bar update
    updateTempBar(cpuTemp);
    
    // Update every 50ms for smooth animation (4 seconds = 80 updates, 40°C range = 0.5°C per update)
    tempAnimationInterval = setInterval(() => {
        // Smoothly increase from 50 to 90, then decrease back to 50
        if (increasing) {
            cpuTemp += 0.5;
            gpuTemp += 0.48;
            if (cpuTemp >= 90) {
                increasing = false;
            }
        } else {
            cpuTemp -= 0.5;
            gpuTemp -= 0.48;
            if (cpuTemp <= 50) {
                increasing = true;
            }
        }
        
        // Update display
        cpuTempElement.textContent = Math.round(cpuTemp) + '°C';
        gpuTempElement.textContent = Math.round(gpuTemp) + '°C';
        
        // Update text color based on temperature
        if (cpuTemp < 60) {
            cpuTempElement.style.color = '#0a84ff'; // Blue - Cool
        } else if (cpuTemp < 70) {
            cpuTempElement.style.color = '#00d4ff'; // Cyan - Moderate
        } else if (cpuTemp < 80) {
            cpuTempElement.style.color = '#ffd60a'; // Yellow - Warm
        } else {
            cpuTempElement.style.color = '#ff3b30'; // Red - Hot
        }
        
        // Update visual bar
        updateTempBar(cpuTemp);
    }, 50);
}

// Start temperature animation when page loads if monitoring tab exists
document.addEventListener('DOMContentLoaded', () => {
    const monitoringTab = document.querySelector('[onclick*="monitoring"]');
    if (monitoringTab) {
        monitoringTab.addEventListener('click', () => {
            setTimeout(animateTemperatures, 100);
        });
    }
    
    // Initialize LED strip with rainbow animation by default
    const ledStrip = document.querySelector('.led-strip');
    if (ledStrip) {
        // Add rainbow class with slight delay to ensure CSS is loaded
        setTimeout(function() {
            ledStrip.classList.add('rainbow');
            
            // Force animation start by triggering reflow
            const pixels = ledStrip.querySelectorAll('.strip-pixel');
            for (let i = 0; i < pixels.length; i++) {
                pixels[i].style.animation = 'none';
                pixels[i].offsetHeight; // Trigger reflow
                pixels[i].style.animation = '';
            }
        }, 100);
    }
});

